import { RouteItem } from '@eastcoal/router/types/route'

import {
  BRAND_LIST_PAGE_PATH,
  BRAND_CREATE_PAGE_PATH,
  BRAND_EDIT_PAGE_PATH,
  BRAND_DETAIL_PAGE_PATH
} from './constants/path'
import { BRAND_LIST_PAGE_UUID, BRAND_ACTION_UUID } from './constants/uuid'

export const brandRoute: RouteItem = {
  title: '合作企业',
  hideChildrenInMenu: true,
  uuid: BRAND_LIST_PAGE_UUID,
  children: [
    {
      title: '列表',
      path: BRAND_LIST_PAGE_PATH,
      Component: () => import('./List')
    },
    {
      title: '新增',
      path: BRAND_CREATE_PAGE_PATH,
      Component: () => import('./Create')
    },
    {
      title: '编辑',
      path: BRAND_EDIT_PAGE_PATH,
      Component: () => import('./Edit')
    },
    {
      title: '详情',
      path: BRAND_DETAIL_PAGE_PATH,
      Component: () => import('./Detail')
    },
    {
      title: '管理操作',
      uuid: BRAND_ACTION_UUID
    }
  ]
}
